// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"ToggleIcon_ProseMirror__3QqkT","arrow":"ToggleIcon_arrow__1SBbS","arrow_expanded":"ToggleIcon_arrow_expanded__3AEjj"};